import React, { useContext, useEffect } from "react";
import './theOutlet.style.scss';
import { AccountContext } from "../../../Contexts/main.context";
import ReadOnlyClientView from "../../DisplayBox/ViewClient/viewClient.component";
import EditClient from "../../DisplayBox/EditClient/editClient.component";
import '../../../assets/CSS/bootstrap-5-48-LGO.css';
import ClientLocations from "../../DisplayBox/Locations/locations.component";
import CitationsList from "../../DisplayBox/ShowLocations/showLocations.component";
import CitationUploader from "../../DisplayBox/UploadCitation/uploadCitation.component";
import FollowUp from "../../DisplayBox/FollowUp/FollowUp.component";
import ChangeLog from "../../DisplayBox/ChangeLog/ChangeLog.component";
import { jwtDecode } from "jwt-decode";
import UsersComponent from "../../DisplayBox/LGOUsers/lgoUsers.component";
import MyUserAccount from "../../DisplayBox/MyUserAccount/myUserAccount.component";
import CreateLGOAccount from "../../DisplayBox/createLGOAccount/createLGOAccount.component";

const TheOutlet = () => {
    const { activeOutlet, activeClient,myAccount,updateMyAccount } = useContext(AccountContext);

     useEffect(()=>{
          if (myAccount.length === 0) {
          const token = localStorage.getItem('LGOUser');
          const theLGOUser =  jwtDecode(token);
          updateMyAccount(theLGOUser);
          console.log(theLGOUser);
     }
     },[myAccount])

    const renderOutlet = () => {
        // 🔒 Guard clause: Wait for activeClient to be defined and not null
        if (!activeClient) return null;
        if (typeof activeOutlet === "string") {
            switch (activeOutlet) {
                case 'editCustomer':
                    return <EditClient clientData={activeClient} />;
                case 'ViewCustomer':
                    return <ReadOnlyClientView client={activeClient} />;
                case 'ViewLocation':
                    return <ClientLocations />;
                case 'ViewCitations':
                    return <CitationsList />;
               case 'AddCitation' :
                    return <CitationUploader />
                    // return <UsersComponent />
               case 'followUp' :
                    return <FollowUp />
               case 'changeLog' :
                    return <ChangeLog />
               case 'Users' :
                    return <UsersComponent />
               case 'Account' :
                    return <MyUserAccount />
               case 'New' :
                    return <CreateLGOAccount />
                default:
                    return <ClientLocations />;
            }
        }

        return null;
    };

    return (
        <div id="theOutlet" style={{zIndex:"2000"}}>
            {renderOutlet()}
        </div>
    );
};

export default TheOutlet;
